import './Wrapper.css';const wrapper_drawer = "_wrapper_drawer_1y76z_1";
const styles = {
  wrapper_drawer
};
export {
  styles as default,
  wrapper_drawer
};
